import {
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
} from '@angular/core';
import { PercentToValuePipe } from '@marmon/frontend/common';
import {
	CellColorCode,
	ColorCodeCellBase,
} from './color-code-cell-base.component';

@Component({
	standalone: true,
	providers: [PercentToValuePipe],
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'mar-margin-percent-twenty-cell',
	templateUrl: 'color-code-cell.component.html',
	host: { class: 'flex gap-2 items-center' },
})
export class MarginPercentTwentyCellComponent extends ColorCodeCellBase<number> {
	readonly marginPercent80 = input.required<number | null>();
	readonly toValue = inject(PercentToValuePipe);

	override readonly formattedValue = computed(() =>
		this.toValue.transform(this.value()),
	);

	override getColorCode(value: number): CellColorCode {
		const percent80 = this.marginPercent80() ?? 0;
		const delta = value - percent80;
		if (delta >= 0.05) return 'green';
		else if (delta >= 0) return 'yellow';
		return 'red';
	}
}
